/* tslint:disable:all */
import { Component, OnInit } from '@angular/core';
import {ComponentBase} from '../../core/entities/component-base';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent extends ComponentBase implements OnInit {

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/layout/footer/footer.component.ts